import React from "react";
import {
  Accordion,
  Headline,
  SectionContent,
  TextBodyAccordion,
} from "../../../../components";
import * as S from "./CoberturasAdicionais.Style";

const CoberturasAccordionLeft = [
  {
    title: "Colisão de veículos e queda de aeronaves",
    body: (
      <TextBodyAccordion>
        Ideal para quem mora em ruas e avenidas movimentadas. Se um veículo
        (carro, caminhão, ônibus, motocicleta, etc.) ou aeronave (avião,
        helicóptero, etc.) causar algum dano ou perda na sua casa, você receberá
        o valor contratado para reparar o imóvel.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Danos elétricos",
    body: (
      <TextBodyAccordion>
        Garante o pagamento das perdas e danos causados por acidente elétrico
        como uma descarga elétrica que consequentemente queime seus
        eletrodomésticos, máquinas ou instalações.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Danos corporais ou materiais a terceiros",
    body: (
      <TextBodyAccordion>
        Se acontecer um incidente e você for responsabilizado civilmente, em
        sentença judicial, a reparar danos corporais ou materiais causados
        acidentalmente a outras pessoas, você será reembolsado.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Furto ou roubo",
    body: (
      <TextBodyAccordion>
        Em caso de roubo, furto ou extorsão, essa cobertura garante o pagamento
        dos bens levados ou danificados e dos danos causados a sua residência
        permanente. Essa cobertura não está disponível para sua casa de lazer e
        descanso (veraneio).
      </TextBodyAccordion>
    ),
  },
  {
    title: "Perda ou pagamento de aluguel",
    body: (
      <TextBodyAccordion>
        Se for preciso desocupar o imóvel por algum imprevisto e você tenha
        alguma dessas coberturas contratadas: incêndio, queda de raio, explosão,
        fenômenos da natureza ou colisão de veículos/queda de aeronave, recebe
        reembolso dos aluguéis que deixar de receber ou tiver que pagar. Essa
        cobertura pode ser usada enquanto o imóvel estiver sem condições de uso.
      </TextBodyAccordion>
    ),
  },
];

const CoberturasAccordionRight = [
  {
    title: "Prejuízos causados por tumultos e greves",
    body: (
      <TextBodyAccordion>
        Caso aconteça alguma manifestação, protesto e outros tipos de
        aglomeração que causem prejuízos ao seu imóvel, você recebe o reembolso
        para o reparo.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Roubo e furto de equipamentos portáteis",
    body: (
      <TextBodyAccordion>
        Caso seus bens cinematográficos, fotográficos e computadores portáteis
        sejam roubados, por meio do uso de força física ou arrombamento do
        imóvel, você recebe uma indenização de até o valor contratado.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Quebra de vidros, blindex, espelhos e mármore",
    body: (
      <TextBodyAccordion>
        Não importa se foi espontaneamente, por imprudência ou por causa da
        chuva, essa cobertura cobre perdas e danos gerados pela quebra de
        vidros, espelhos, blindex, mármores e granito. Esses materiais devem
        estar fixamente instalados na estrutura do seu imóvel, como por exemplo
        janelas de vidro ou paredes de blindex. Box de banheiro não entra nessa
        cobertura.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Vendaval, granizo, fumaça, furacão, ciclone e tornado",
    body: (
      <TextBodyAccordion>
        Garante o pagamento das perdas e danos causados diretamente por um
        desses eventos no imóvel e nos bens que estavam dentro dele.
      </TextBodyAccordion>
    ),
  },
];

const CoberturasAdicionais = () => {
  return (
    <SectionContent>
      <S.SectionHeadline
        as={Headline}
        nivel="2"
        styleAs="4"
        text="Coberturas adicionais"
        leadMobile
      />
      <S.AccordionContainer>
        <Accordion listItems={CoberturasAccordionLeft} />
        <Accordion listItems={CoberturasAccordionRight} />
      </S.AccordionContainer>
    </SectionContent>
  );
};

export default CoberturasAdicionais;
